import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import './Checkout.css';

const NexiCancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="checkout-page">
      <div className="container">
        <div className="checkout-success">
          <div className="success-icon error">✕</div>
          <h1>{t('nexi.cancel.title')}</h1>
          <p>{t('nexi.cancel.message')}</p>
          <div className="result-actions">
            <button className="btn btn-outline" onClick={() => navigate('/checkout')}>
              {t('nexi.cancel.back_checkout')}
            </button>
            <button className="btn btn-primary" onClick={() => navigate('/')}>
              {t('nexi.cancel.back_home')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NexiCancel;

